import { useQuery } from '@tanstack/react-query'
import { topBulkPurchaseTitlesKeys } from '@!/Api/queryKeys'
import { getTopBulkPurchaseTitlesApi } from '@!/Api/bulkPurchaseTitles'
import { useAtom } from 'jotai'
import { safeSearchAtom } from '@!/atoms/safeSearchAtom'

export const useTopBulkPurchaseTitles = (genreName) => {
  const [safeSearch] = useAtom(safeSearchAtom)

  const { data } = useQuery({
    queryKey: topBulkPurchaseTitlesKeys.filtered(safeSearch),
    queryFn: async () => {
      return await getTopBulkPurchaseTitlesApi(safeSearch)
    },
    enabled: genreName === null || genreName === undefined,
    refetchOnWindowFocus: false,
  })

  return data || []
}
